import { Transition } from 'react-transition-group';
import { Snackbar } from '@mui/base/Snackbar';
import { SnackbarCloseReason } from '@mui/base/useSnackbar';
import s from './styles.scss';
import React, { useState, useRef, Dispatch, SetStateAction } from 'react';
import { Icon, enums as e, Pill } from 'edrolo-ui';

type positionStatus =
  | 'entering'
  | 'entered'
  | 'exiting'
  | 'exited'
  | 'unmounted';

interface ToastProps {
  children: React.ReactNode;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const ToastDeprecated = ({
  children,
  isOpen,
  setIsOpen,
}: ToastProps) => {
  const [exited, setExited] = useState(true);
  const nodeRef = useRef(null);

  const handleClose = (_: unknown, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsOpen(false);
  };

  const handleOnEnter = () => {
    setExited(false);
  };

  const handleOnExited = () => {
    setExited(true);
  };

  const positioningStyles = {
    entering: 'translateX(0)',
    entered: 'translateX(0)',
    exiting: 'translateX(500px)',
    exited: 'translateX(500px)',
    unmounted: 'translateX(500px)',
  };

  return (
    <Snackbar
      autoHideDuration={8000}
      open={isOpen}
      onClose={handleClose}
      exited={exited}
      className={s.wrapper}
    >
      <Transition
        timeout={{ enter: 400, exit: 400 }}
        in={isOpen}
        appear
        unmountOnExit
        onEnter={handleOnEnter}
        onExited={handleOnExited}
        nodeRef={nodeRef}
      >
        {(status: positionStatus) => (
          <div
            className={s.toast}
            style={{
              transform: positioningStyles[status],
              transition: 'transform 300ms ease',
            }}
            ref={nodeRef}
          >
            {children}
            <button className={s.close} onClick={() => setIsOpen(false)}>
              <Pill
                variant={e.PillVariant.CIRCLE}
                color={e.ColorTheme.BACKGROUND}
                size={e.Size.SMALL}
              >
                <Icon size={e.Size.SMALL} name={e.Icons.CROSS} />
              </Pill>
            </button>
          </div>
        )}
      </Transition>
    </Snackbar>
  );
};
